import { BROWSER } from '@/constants';
import { browserAxios } from '@/lib/axios';

import { API_AUTH_RESULT_CODE } from './apiAuth';

/**
 * リクエストパラメータ
 */
export type SerialAuthApiRequest = {
  // シリアル
  serial: string;
};

/**
 * 結果コード
 */
export const SERIAL_AUTH_API_RESULT_CODE = {
  ...({
    // 成功
    OK: 'OK',
    // 入力パラメータエラー
    WARN_INPUT_PARAM: 'WARN_INPUT_PARAM',
    // ライセンス登録されていない
    INFO_INVALID_LICENSE: 'INFO_INVALID_LICENSE',
    // ライセンス期限切れ
    INFO_EXPIRED_LICENSE: 'INFO_EXPIRED_LICENSE',
    // 対象のシリアルが既に他のPTIDと連携済み
    INFO_ALREADY_LINKED: 'INFO_ALREADY_LINKED',
    // 対象のシリアルと利用サービスが不一致
    INFO_INVALID_SERVICE: 'INFO_INVALID_SERVICE',
    // 外部API呼び出し失敗
    WARN_FAILED_CALL: 'WARN_FAILED_CALL',
    // 不明なエラー
    ERR_UNKNOWN: 'ERR_UNKNOWN',
  } as const),
  ...API_AUTH_RESULT_CODE,
} as const;

export type SerialAuthApiResultCode =
  (typeof SERIAL_AUTH_API_RESULT_CODE)[keyof typeof SERIAL_AUTH_API_RESULT_CODE];

/**
 * 結果コードのTypeGuard
 *
 * @param resultCode
 * @returns
 */
export const isSerialAuthApiResultCode = (
  resultCode: string,
): resultCode is SerialAuthApiResultCode => {
  if (resultCode in SERIAL_AUTH_API_RESULT_CODE) {
    return true;
  }

  return false;
};

/**
 * レスポンス
 */
export type SerialAuthApiResponse = {
  // 結果コード
  resultCode: SerialAuthApiResultCode;
  // QRコード利用時間
  qrHours: number;
};

/**
 * API 呼び出し
 * @param request
 * @returns
 */
const callApi = (
  request: SerialAuthApiRequest,
  isPrivate = false,
): Promise<SerialAuthApiResponse> => {
  let apiUrl: string = BROWSER.API_URL.SERIAL_AUTH;
  if (isPrivate) {
    apiUrl = BROWSER.API_URL.SERIAL_AUTH_PRIVATE;
  }
  // リクエスト送信（POST）
  const response = browserAxios
    .post<SerialAuthApiResponse>(apiUrl, request, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then((apiResponse) => apiResponse.data);

  return response;
};

/**
 * シリアル認証API リクエスト
 * @param request
 * @returns
 */
export const serialAuthApi = (
  request: SerialAuthApiRequest,
  isPrivate?: boolean,
): Promise<SerialAuthApiResponse> => callApi(request, isPrivate ?? false);
